import { BanToggleButton } from 'components/CustomComponents/BanButton';

export const playerColumnData = (onBanAction) => [
  {
    Header: 'Access',
    accessor: 'blockedFromAccess',
    Cell: ({ row }) => (
      <BanToggleButton
        userId={row?.original?.id}
        initialIsBanned={row?.original?.blockedFromAccess}
        onBanAction={onBanAction}
      />
    )
  },
  { Header: 'ID', accessor: 'id' },
  { Header: 'Username', accessor: 'username' },
  { Header: 'Currency', accessor: 'currency' },
  { Header: 'Last balance', accessor: 'balance' },
  { Header: 'Integration', accessor: 'client' },
  { Header: 'Created at', accessor: 'createdAt' },
  { Header: 'Updated at', accessor: 'updatedAt' }
];
